module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M30 0h-7a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h5v24H4V4h5a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1H2C.894 0 0 .894 0 2v28c0 1.106.894 2 2 2h28c1.106 0 2-.894 2-2V2c0-1.106-.894-2-2-2zM15.354 19.644c.358.468.936.476 1.292.008L21.82 13c.358-.472.164-1-.43-1H18V1c0-.55-.448-1-1-1h-2c-.552 0-1 .45-1 1v11h-3.39c-.594 0-.788.53-.43 1l5.174 6.644z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/move-down-1.js
// module id = 1288
// module chunks = 14